export default "__VITE_ASSET__DNQL$lFA__"